import React from 'react';
import * as Icons from 'lucide-react';
import { WHY_TARHUN } from '../data/mock';
import { Reveal } from './effects';

const WhyTarhun = () => {
  return (
    <section className="relative py-28 lg:py-44 bg-[#72272D] overflow-hidden">
      <div
        className="absolute inset-0 opacity-[0.05] pointer-events-none"
        style={{
          backgroundImage:
            'radial-gradient(circle at 1px 1px, rgba(255,255,255,1) 1px, transparent 0)',
          backgroundSize: '32px 32px',
        }}
      />

      <div className="absolute top-0 inset-x-0 h-px bg-gradient-to-r from-transparent via-[#C9A875]/45 to-transparent" />
      <div className="absolute bottom-0 inset-x-0 h-px bg-gradient-to-r from-transparent via-[#C9A875]/45 to-transparent" />

      <div className="relative container-x">
        <div className="text-center mb-16 lg:mb-24 max-w-3xl mx-auto">
          <Reveal delay={0} y={20}>
            <div className="inline-flex items-center gap-3 mb-7">
              <span className="h-px w-12 bg-[#C9A875]" />
              <span className="text-[10.5px] tracking-[0.35em] uppercase text-[#C9A875] font-medium">
                Neden Tarhun
              </span>
              <span className="h-px w-12 bg-[#C9A875]" />
            </div>
          </Reveal>

          <Reveal delay={150}>
            <h2
              className="font-display text-[36px] lg:text-[60px] text-[#F5F0E5] leading-[1.04] tracking-[-0.02em]"
              style={{ fontWeight: 500 }}
            >
              Yemek değil,{' '}
              <span className="italic font-light text-[#C9A875]">sistem</span>{' '}
              teslim ediyoruz.
            </h2>
          </Reveal>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4">
          {WHY_TARHUN.map((p, i) => {
            const Icon = Icons[p.icon] || Icons.Sparkles;
            return (
              <Reveal key={i} delay={i * 140} y={28}>
                <div
                  className={`relative px-7 lg:px-10 py-8 lg:py-10 group/pillar
                    ${i !== 0 ? 'lg:border-l border-[#C9A875]/22' : ''}
                    ${i !== WHY_TARHUN.length - 1 ? 'border-b md:border-b-0 lg:border-b-0' : ''}
                    ${i % 2 === 0 ? 'md:border-r lg:border-r-0' : ''}
                    border-[#C9A875]/22`}
                >
                  <div className="text-[10.5px] numeric tracking-[0.32em] text-[#C9A875]/70 mb-6">
                    0{i + 1}
                  </div>

                  <Icon
                    size={28}
                    strokeWidth={1.4}
                    className="text-[#C9A875] mb-6 transition-transform duration-500 group-hover/pillar:translate-y-[-3px] group-hover/pillar:scale-[1.06]"
                  />

                  <h3 className="font-display text-[24px] lg:text-[28px] text-[#F5F0E5] leading-[1.1] tracking-[-0.005em]">
                    {p.title}
                  </h3>
                  <p
                    className="mt-4 text-[14.5px] leading-[1.7]"
                    style={{ color: 'rgba(245, 240, 229, 0.78)' }}
                  >
                    {p.desc}
                  </p>
                </div>
              </Reveal>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default WhyTarhun;
